import styled from 'styled-components';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import LandingArrow from './LandingArrow';

const LandingPlansStyled = styled.section``;

function LandingPlans({ onOpenContact, onOpenPlanHelp }) {
    const { getLangPath } = useLangContext();
    const orLabel = getLangPath('landing.plans.or');
    const perLot = getLangPath('landing.plans.perLot');

    return (
        <LandingPlansStyled className="block white" id="plans">
            <div className="wrap">
                <div className="section-head">
                    <div>
                        <div className="kicker">{getLangPath('landing.plans.kicker')}</div>
                        <h2>{getLangPath('landing.plans.title')}</h2>
                    </div>
                    <div className="plans-help-row">
                        <button
                            type="button"
                            className="plans-help-button"
                            id="open-plan-help"
                            aria-haspopup="dialog"
                            aria-controls="plan-help-dialog"
                            onClick={onOpenPlanHelp}
                        >
                            <span aria-hidden="true">i</span>
                            {getLangPath('landing.plans.terms')}
                        </button>
                    </div>
                </div>
                <div className="plans">
                    <article className="plan">
                        <div className="plan-top">{getLangPath('landing.plans.planA')}</div>
                        <h3>{getLangPath('landing.plans.planATitle')}</h3>
                        <p className="intro">{getLangPath('landing.plans.planAIntro')}</p>
                        <div className="rate">
                            $100
                            {' '}
                            <small><span>/ FTD</span></small>
                        </div>
                        <p className="alt">
                            <span className="or">{orLabel}</span>
                            <b>$300 / QFTD</b>
                        </p>
                    </article>
                    <article className="plan">
                        <div className="plan-top">{getLangPath('landing.plans.planB')}</div>
                        <h3><span>{getLangPath('landing.plans.planBTitle')}</span></h3>
                        <p className="intro">{getLangPath('landing.plans.planBIntro')}</p>
                        <div className="hybrid-rates">
                            <div className="rate">
                                $50
                                {' '}
                                <small>/ FTD</small>
                            </div>
                            <span className="rate hybrid-plus" aria-label={getLangPath('landing.plans.plus')}>+</span>
                            <div className="rate hybrid-rebate">
                                $12
                                {' '}
                                <small>{perLot}</small>
                            </div>
                        </div>
                        <p className="alt">
                            <span className="or">{orLabel}</span>
                            <b>$250 / QFTD</b>
                        </p>
                    </article>
                    <article className="plan featured">
                        <div className="plan-top">
                            {getLangPath('landing.plans.planC')}
                            {' '}
                            <span className="early-bird-label">{getLangPath('landing.plans.earlyBird')}</span>
                        </div>
                        <h3>{getLangPath('landing.plans.planCTitle')}</h3>
                        <p className="intro">{getLangPath('landing.plans.planCIntro')}</p>
                        <div className="rate">
                            $18
                            {' '}
                            <small><span>{perLot}</span></small>
                        </div>
                        <p className="alt">
                            <span className="or">{orLabel}</span>
                            <b>85% RevShare</b>
                            {' '}
                            {getLangPath('landing.plans.ofLosses')}
                        </p>
                    </article>
                </div>
                <div className="partner-bonus-offer">
                    <div className="partner-bonus-area">
                        <div className="partner-bonus-strip">
                            <div className="partner-bonus-item">
                                <h3><span>{getLangPath('landing.plans.volumeTitle')}</span></h3>
                                <div className="partner-bonus-amount">
                                    $100
                                    <span>
                                        {' '}
                                        {getLangPath('landing.plans.perHundredLots')}
                                    </span>
                                </div>
                                <p>{getLangPath('landing.plans.volumeText')}</p>
                            </div>
                            <div className="partner-bonus-item">
                                <h3><span>{getLangPath('landing.plans.subTitle')}</span></h3>
                                <div className="partner-bonus-amount">+15%</div>
                                <p>{getLangPath('landing.plans.subText')}</p>
                            </div>
                            <div className="partner-bonus-item">
                                <h3>{getLangPath('landing.plans.incentivesTitle')}</h3>
                                <div className="partner-incentive-content">{getLangPath('landing.plans.incentivesValue')}</div>
                                <p>{getLangPath('landing.plans.incentivesText')}</p>
                            </div>
                        </div>
                    </div>
                    <button className="btn" type="button" aria-haspopup="dialog" aria-controls="contact" onClick={onOpenContact}>
                        {getLangPath('landing.plans.specialCta')}
                        {' '}
                        <LandingArrow/>
                    </button>
                </div>
            </div>
        </LandingPlansStyled>
    );
}

export default LandingPlans;
